import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";

export const selectDialogsState = (state: RootState) => state.dialogsState;

export const selectDialogValue = createSelector(selectDialogsState, (state) => {
  return state.dialogValue;
});

export const selectDialogSelectedAssistant = createSelector(
  selectDialogsState,
  (state) => {
    return state.selectedAssistant;
  },
);

export const selectDialogMessages = createSelector(
  selectDialogsState,
  (state) => {
    return state.messages;
  },
);

export const selectPreviousResponseId = createSelector(
  selectDialogsState,
  (state) => {
    if (
      !state.dialogValue ||
      !state.dialogValue?.dialog_object?.previous_response_id
    )
      return null;
    return state.dialogValue.dialog_object.previous_response_id;
  },
);

export const selectIsMessageLoading = createSelector(
  selectDialogsState,
  (state) => {
    return state.isMessageLoading;
  },
);

export const selectIsFileLoading = createSelector(
  selectDialogsState,
  (state) => {
    return state.isFileLoading;
  },
);
